const reShortId = /^\d{2}[A-Za-z]{2,3}[0-9a-zA-Z]{8}$/;
const reUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export { reShortId, reUuid };
